import React from 'react';
import { GiPartyPopper } from 'react-icons/gi';
import { useNavigate } from 'react-router-dom';
import './CongratsPopup.scss';
import { FaCalendarCheck, FaTriangleExclamation } from 'react-icons/fa6';

interface Props {
  onClose: () => void;
  freeDaysLeft: number;
  isPlanActive: boolean;
  daysLeft: number;
}

const CongratsPopup = ({
  onClose,
  freeDaysLeft,
  isPlanActive,
  daysLeft,
}: Props) => {
  const navigate = useNavigate();

  return (
    <div className="congrats-popup">
      <div className="popup-content">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        {freeDaysLeft > 0 ? (
          <div className="popup-header">
            {freeDaysLeft > 7 ? (
              <>
                <GiPartyPopper className="party-icon" />
                <h4>Congratulations!</h4>
              </>
            ) : (
              <>
                <FaTriangleExclamation className="party-icon" />
                <h4>Subscribe Now!</h4>
              </>
            )}
          </div>
        ) : isPlanActive ? (
          <div className="popup-header">
            <FaCalendarCheck className="party-icon" />
            <h4>Package Active!</h4>
          </div>
        ) : (
          <div className="popup-header">
            <FaTriangleExclamation className="expired" />
            <h4>Package Expired!</h4>
          </div>
        )}
        <div className="popup-body">
          {freeDaysLeft > 7 ? (
            <p>
              You still have <b>{freeDaysLeft} days</b> of free access.
            </p>
          ) : freeDaysLeft <= 7 && freeDaysLeft > 0 ? (
            <p>
              You have <b>{freeDaysLeft} days</b> of free access left. To
              continue you listing subscribe our package.
            </p>
          ) : isPlanActive ? (
            <p>
              Your package will expire in <b>{daysLeft} days</b>.
            </p>
          ) : (
            <p>Your plan has expired. Please subscribe our package.</p>
          )}
          <button
            className="btn btn-primary"
            onClick={() => {
              navigate('/dashboard/Package');
              onClose();
            }}
          >
            Explore our packages
          </button>
        </div>
      </div>
    </div>
  );
};

export default CongratsPopup;
